// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>24</span>&nbsp;&nbsp;Cast your burden upon the Lord and he will sustain you,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and will not let the righteous fall for ever.<br> </p> </div></div>";
// Exports
module.exports = code;